/**
 * @kantera/i18n/useTranslationTyped
 * Type-safe wrapper over react-i18next's useTranslation hook
 *
 * Provides compile-time validation of translation keys,
 * preventing runtime errors from typos or removed strings.
 */
import { useTranslation as useI18nextTranslation } from 'react-i18next';
/**
 * Hook to access translations with TypeScript safety.
 * Usage:
 *   const { t } = useTranslationTyped();
 *   const title = t('dashboard.title');
 */
export function useTranslationTyped() {
    const { t: i18nT, ...rest } = useI18nextTranslation();
    // Cast i18next's t function to our type-safe version
    const t = i18nT;
    return {
        t,
        ...rest,
    };
}
//# sourceMappingURL=useTranslationTyped.js.map